// extracted by mini-css-extract-plugin
module.exports = {"section":"_3YHkTc1_TN7xMbMaDZnhJ7","inner":"_33OsiXEXk7yncFA8a_9Ux9","body":"_22KJteq1EbBKRxPuoL9hm"};